import React from "react";
import { useRegisterStateValue } from "../../RegisterContext";
import { purchaserValidator } from "../../register.validator";
import PurchaserForm from "./PurchaserForm";
import { withLocalizeStrings } from "../../../languages/Localize";
import { Formik } from "formik";
import { Box } from "reflexbox/styled-components";
import styled from "styled-components";
import { Button } from "antd";
import TitleSeparator from "../../../components/title-separator/TitleSeparator";
import PaymentGateway from "../../payment-gateway/PaymentGateway";
import { Spin } from "antd";

const StyledDescription = styled(Box)`
    color: ${({ theme }) => theme.colors.white};
    text-align: justify;
`;

const StyledButtonContainer = styled(Box)`
    text-align: center;
`;

const StyledButton = styled(Button)`
    color: ${({ theme }) => theme.colors.primary};
    width: 60%;
    min-width: 180px;
    height: 50px;
    border: none;
    font-weight: 700;
    border-radius: 8px;
    text-transform: uppercase;
    font-size: 24px;
    &:focus,
    &:hover {
        color: ${({ theme }) => theme.colors.primary};
    }
    &:active {
        color: ${({ theme }) => theme.colors.primary};
    }
`;

const PurchaserScreen = ({ strings }) => {
    const { purchaserForm, purchaserFormValid, setPurchaserFormField, setPurchaserFormValid, nextScreen, paymentGatewayForm, loading } =
        useRegisterStateValue();

    if (loading) {
        return <Spin />;
    }

    return (
        <>
            {!paymentGatewayForm ? (
                <>
                    <TitleSeparator>{strings.register.common.PURCHASER_HEADER}</TitleSeparator>
                    <StyledDescription
                        sx={{
                            m: [3, 4],
                            px: [1, 2],
                            fontSize: [2, 3]
                        }}>
                        {strings.register.common.PURCHASER_DESCRIPTION}
                    </StyledDescription>
                    <Box className="required-label first" sx={{ m: [3, 4], px: [1, 2] }}>
                        {strings.register.common.REQUIRED_LABEL}
                    </Box>
                    <Formik validationSchema={purchaserValidator(strings)} initialValues={purchaserForm} isInitialValid={purchaserFormValid}>
                        {innerPops => <PurchaserForm onValidityChange={setPurchaserFormValid} onFormChange={setPurchaserFormField} {...innerPops} />}
                    </Formik>
                    <StyledButtonContainer sx={{ m: [3, 4], px: [1, 2], fontSize: [2, 3] }}>
                        <StyledButton disabled={!purchaserFormValid} onClick={() => nextScreen()}>
                            {strings.register.common.PURCHASER_BUTTON}
                        </StyledButton>
                    </StyledButtonContainer>
                </>
            ) : (
                <div>
                    <PaymentGateway />
                </div>
            )}
        </>
    );
};
export default withLocalizeStrings(PurchaserScreen);
